import Connection from './connection'
import Store from './store'

export default class Tags extends Store {
  constructor() {
    super(new Connection('tags'))
  }
}



// WEBPACK FOOTER //
// client/stores/tags.js